export default function clearUserTokens() {
  localStorage.removeItem("Hstm.Identity.AccessToken");
  localStorage.removeItem("Hstm.Identity.IdentityToken");
}
